import { render, staticRenderFns } from "./BrandColorsModal.vue?vue&type=template&id=51c528d2&scoped=true"
import script from "./BrandColorsModal.vue?vue&type=script&lang=js"
export * from "./BrandColorsModal.vue?vue&type=script&lang=js"
import style0 from "./BrandColorsModal.vue?vue&type=style&index=0&id=51c528d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c528d2",
  null
  
)

export default component.exports